

function defaultEventDetails(override){
	return Object.assign({
		display:{
			getSimpleDisplayString({dataChange}){

			}
		}
	}, override);
}



const AuditEvents = {
	recordFieldChanged: defaultEventDetails({
		display:{
			getSimpleDisplayString({dataChange}){
				const {record, fieldGUID, previousValue, changedValue} = dataChange.details;

				// WARNING
				//getDisplayLabel needs a vue component to work now.
				//But this code was unusued at the point of making that
				//So not updated
				const recordLabel = record.getDisplayLabel();
				const fieldLabel = dataChange.dataStore.meta.schema.fields[fieldGUID].display.label;

				return `Changed ${fieldLabel} on ${recordLabel} from ${(previousValue ? previousValue.value : previousValue)} to ${(changedValue ? changedValue.value : changedValue)}`;

			}
		}
	}),
	sheetViewCreated: defaultEventDetails({

	})
};

export default AuditEvents;